import { apiSlice } from "../apiSlice";

export const employeeApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getEmployee: builder.query({
      query: ({ page, query, employee_id, search }) => {
        // Start with the base URL
        let url = `/org/employee/list/?`;

        // Append page if it is defined
        if (page !== undefined) {
          url += `page=${page}`;
        }

        // Append query if it is defined
        if (query) {
          url += `${url.endsWith("?") ? "" : "&"}${query}`;
        }

        // Append employee_id if it is defined
        if (employee_id !== undefined) {
          url += `${url.endsWith("?") ? "" : "&"}employee_id=${employee_id}`;
        }

        // Append search if it is defined
        if (search) {
          url += `${url.endsWith("?") ? "" : "&"}search=${search}`;
        }

        return url;
      },
      keepUnusedDataFor: 0,
    }),
    getEmployeeExcelTemplate: builder.query({
      query: () => {
        return {
          url: `/org/employee/download-sample-csv/`,
          method: "GET",
          responseHandler: async (response) => {
            if (response.ok) {
              return response.blob();
            } else {
              const errorData = await response.json(); // Parse the error response
              return errorData;
            }
          },
        };
      },
    }),
    exportEmployeeExcel: builder.query({
      query: (id) => {
        return {
          url: `/org/employee/export-csv/?org_id=${id}`,
          method: "GET",
          responseHandler: async (response) => {
            if (response.ok) {
              return response.blob();
            } else {
              const errorData = await response.json(); // Parse the error response
              return errorData;
            }
          },
        };
      },
    }),
    postEmployeeCsv: builder.mutation({
      query: (newPackage) => ({
        url: "/org/employee/import-csv/",
        method: "POST",
        body: newPackage,
      }),
    }),
    addEmployee: builder.mutation({
      query: (empdata) => {
        const formData = new FormData();
        
        // Handle arrays separately
        if (empdata.departments) {
          formData.append('departments', Array.isArray(empdata.departments) ? empdata.departments.join(',') : empdata.departments);
        }
        if (empdata.teams) {
          formData.append('teams', Array.isArray(empdata.teams) ? empdata.teams.join(',') : empdata.teams);
        }
        if (empdata.managers) {
          formData.append('managers', Array.isArray(empdata.managers) ? empdata.managers.join(',') : empdata.managers);
        }
        if (empdata.certifications) {
          formData.append('certifications', Array.isArray(empdata.certifications) ? empdata.certifications.join(',') : empdata.certifications);
        }

        // Handle all other fields
        Object.keys(empdata).forEach(key => {
          if (!['departments', 'teams', 'managers', 'certifications'].includes(key)) {
            formData.append(key, empdata[key]);
          }
        });

        return {
          url: "/org/employee/",
          method: "POST",
          body: formData,
          formData: true
        };
      },
    }),
    editEmployee: builder.mutation({
      query: (data) => {
        const formData = new FormData();

        // Append as comma-separated strings
        if (data.departments) {
          formData.append('departments', Array.isArray(data.departments) ? data.departments.join(',') : data.departments);
        }
        if (data.teams) {
          formData.append('teams', Array.isArray(data.teams) ? data.teams.join(',') : data.teams);
        }
        if (data.managers) {
          formData.append('managers', Array.isArray(data.managers) ? data.managers.join(',') : data.managers);
        }
        if (data.certifications) {
          formData.append('certifications', Array.isArray(data.certifications) ? data.certifications.join(',') : data.certifications);
        }

        // Append all other fields
        Object.keys(data).forEach(key => {
          if (!['departments', 'teams', 'managers', 'certifications'].includes(key)) {
            if (data[key] !== null && data[key] !== undefined) {
              formData.append(key, data[key]);
            }
          }
        });

        return {
          url: "/org/employee/",
          method: "PUT",
          body: formData,
          formData: true,
          headers: {
            'Accept': 'application/json'
          }
        };
      },
      invalidatesTags: ['Employee']
    }),
    deleteEmployee: builder.mutation({
      query: (employee_ids) => ({
        url: "/org/employee/",
        method: "DELETE",
        body: employee_ids,
      }),
    }),
    getEmployeeMyEmpObj: builder.query({
      query: () => "org/employee/my_emp_obj/",
      keepUnusedDataFor: 5,
    }),
    editEmployeeMyEmpObj: builder.mutation({
      query: (empdata) => ({
        url: "org/employee/my_emp_obj/",
        method: "PUT",
        body: empdata,
      }),
    }),
  }),
});

export const {
  useGetEmployeeQuery,
  useLazyGetEmployeeExcelTemplateQuery,
  useLazyExportEmployeeExcelQuery,
  usePostEmployeeCsvMutation,
  useAddEmployeeMutation,
  useEditEmployeeMutation,
  useDeleteEmployeeMutation,
  useGetEmployeeMyEmpObjQuery,
  useEditEmployeeMyEmpObjMutation,
} = employeeApiSlice;
